import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

@observer
class WebCamCapture extends Component {
    @observable myVideo = null;
    @observable canvas = null;

    @action videoRef = (node) => {
        this.myVideo = node;
    };
    @action canvasRef = (node) => {
        this.canvas = node;
    };

    componentDidMount = async () => {
        this.myVideo.srcObject = this.props.webCamProps.stream;
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: {ideal: 1280},
                    height: {ideal: 720}
                },
                audio: false
            });
            this.handleSuccess(stream);
        } catch (err) {
            this.props.webCamProps.handleError(err);
        }
    };

    handleSuccess = (stream) => {
        this.props.webCamProps.handleSuccess(stream, this.canvas, this.myVideo);
        this.myVideo.srcObject = stream;
    };

    componentWillUnmount() {
        this.props.webCamProps.clearWebCam();
    }


    render = () => {
        const {webCamProps, width, height} = this.props;
        const scaleCanvas = 4;
        return (
            <div>
                <div style={{width, height}} className="web-cam__video-holder">
                    <video ref={this.videoRef} width={webCamProps.videoWidth} height={webCamProps.videoHeight} autoPlay muted/>
                </div>
                <canvas style={{display: 'none'}} ref={this.canvasRef} width={width * scaleCanvas || 500} height={height * scaleCanvas || 400}/>
            </div>
        );
    };
}

export default WebCamCapture;

